export default __webpack_public_path__ + "static/media/2304.e41d3c1f.png";